import { IGPSLatLng } from "./demand-gpslatlng.model";
import { IDemandSmartSuggestion, ISmartSuggest } from ".";

export interface IDemandParameterModel {
  Category1Ids?: number[];
  Category1OperatorId?: number;
  Category2Ids?: number[];
  Category2OperatorId?: number;
  CategoryOperator?: string;
  CompanyIds?: number[];
  EndDateFrom?: string;
  EndDateTo?: string;
  EnteredDateFrom?: string;
  EnteredDateTo?: string;
  EnviromentIds?: number[];
  EPC?: number;
  EventIds?: number[];
  EventSinceByUserId?: number;
  EventSinceDate?: string;
  ExteriorComfortIds?: number[];
  FilterDemand?: boolean;
  FootPrint?: number;
  Garage?: number;
  GeoData?: string;
  GeographicIds?: number[];
  GPSAddress?: string;
  GPSLatLng?: IGPSLatLng;
  GroundArea?: number;
  Id?: number;
  InteriorComfortIds?: number[];
  IsDeleted?: boolean;
  IsElevator?: boolean;
  IsFurnished?: boolean;
  IsGarden?: boolean;
  IsNewConstruction?: boolean;
  IsTerrace?: boolean;
  ManagerId?: number;
  MaxBedroom?: number;
  MaxPriceFrom?: number;
  MaxPriceTo?: number;
  MinBedroom?: number;
  MinPriceFrom?: number;
  MinPriceTo?: number;
  NoEventIds?: number[];
  NoEventSinceByUserId?: number;
  NoEventSinceDate?: string;
  NoProposalSinceDate?: string;
  PersonEnteredDateFrom?: string;
  PersonEnteredDateTo?: string;
  PersonGeoData?: string;
  PersonLanguageId?: number;
  PersonManagerId?: number;
  PriceFrom?: number;
  PriceTo?: number;
  PropertyId?: number;
  PropertyIsInnerPlace?: boolean;
  Purpose?: number;
  PurposeId?: number;
  SiteId?: number;
  GoalId?: number;
  StatusId?: number;
  TotalArea?: number;
  TypeOfPropertyIds?: number[];
  UseGeoCity?: boolean;
  InputEntries?: ISmartSuggest[];
  RegionEntries?: IDemandSmartSuggestion[];
  SiteIds?: number[];
  ManagerIds?: number[];
  StatusIds?: number[];
  PurposeIds?:number[];
  GoalIds?:number[];
  Ids?:number[];
}
export class DemandParameterModel implements IDemandParameterModel {
  Category1Ids: number[];
  Category1OperatorId: number;
  Category2Ids: number[];
  Category2OperatorId: number;
  CategoryOperator: string;
  CompanyIds: number[];
  EndDateFrom: string;
  EndDateTo: string;
  EnteredDateFrom: string;
  EnteredDateTo: string;
  EnviromentIds: number[];
  EPC: number;
  EventIds: number[];
  EventSinceByUserId: number;
  EventSinceDate: string;
  ExteriorComfortIds: number[];
  FilterDemand: boolean;
  FootPrint: number;
  Garage: number;
  GeoData: string;
  GeographicIds: number[];
  GPSAddress: string;
  GPSLatLng: IGPSLatLng;
  GroundArea: number;
  Id: number;
  InteriorComfortIds: number[];
  IsDeleted: boolean;
  IsElevator: boolean;
  IsFurnished: boolean;
  IsGarden: boolean;
  IsNewConstruction: boolean;
  IsTerrace: boolean;
  ManagerId: number;
  MaxBedroom: number;
  MaxPriceFrom: number;
  MaxPriceTo: number;
  MinBedroom: number;
  MinPriceFrom: number;
  MinPriceTo: number;
  NoEventIds: number[];
  NoEventSinceByUserId: number;
  NoEventSinceDate: string;
  NoProposalSinceDate: string;
  PersonEnteredDateFrom: string;
  PersonEnteredDateTo: string;
  PersonGeoData: string;
  PersonLanguageId: number;
  PersonManagerId: number;
  PriceFrom: number;
  PriceTo: number;
  PropertyId: number;
  PropertyIsInnerPlace: boolean;
  Purpose: number;
  PurposeId?: number;
  SiteId: number;
  GoalId: number;
  StatusId: number;
  TotalArea: number;
  TypeOfPropertyIds: number[];
  UseGeoCity: boolean;
  InputEntries: ISmartSuggest[];
  RegionEntries: IDemandSmartSuggestion[];
  SiteIds?: number[];
  ManagerIds?: number[];
  StatusIds?: number[];
  PurposeIds?:number[];
  GoalIds?:number[];
  Ids?:number[];
  /**
   *
   */
  constructor(option?: IDemandParameterModel) {
    Object.keys(option).forEach(key => { this[key] = option[key] });
    this.StatusId = option.StatusId || null;
    this.GoalId = option.GoalId || null;
    this.SiteIds = option.SiteIds || [];
    this.ManagerIds = option.ManagerIds || [];
    this.StatusIds = option.StatusIds || [];
    this.PurposeIds = option.PurposeIds || [];
    this.GoalIds = option.GoalIds || [];
    this.Ids = option.Ids || [];
    this.IsDeleted = option.IsDeleted || false;
  }
}